export default __webpack_public_path__ + "static/media/q17_step1.8cd857a7.png";